export default __webpack_public_path__ + "static/media/cmed.b68241cd.png";